import React from "react";
import styles from "./button.module.scss";
import LightweightIcon from "../icon/LightweightIcon";
const LightweightButton = ({ onClick, className, children, icon, color = "", size = "m", id, textButton = false, hidden = false, }) => {
    let classNames = `${className ? className : ""} ${styles.vhvButton} `;
    let iconColor = "primary";
    switch (color.toLowerCase()) {
        case "primary":
            classNames += styles.primary;
            iconColor = "secondary";
            break;
        case "secondary":
            classNames += styles.secondary;
            iconColor = "primary";
            break;
        case "tertiary":
            classNames += styles.tertiary;
            break;
        default:
    }
    switch (size.toLowerCase()) {
        case "s":
            classNames += ` ${styles.sizeS}`;
            break;
        case "m":
            classNames += ` ${styles.sizeM}`;
            break;
        case "l":
            classNames += ` ${styles.sizeL}`;
            break;
        default:
            classNames += ` ${styles.sizeM}`;
    }
    if (textButton) {
        classNames += " " + styles.textButton;
    }
    if (hidden) {
        classNames += " " + styles.hidden;
    }
    return (React.createElement("div", { id: id, className: `${classNames}` },
        React.createElement("button", { onClick: onClick },
            icon && React.createElement(LightweightIcon, { icon: icon, color: iconColor }),
            children)));
};
export default LightweightButton;
